import React from 'react';
import { useLocation } from 'react-router-dom';
import AddressDrawer from './AddressDrawer';

/**
 * AddressGate
 * -----------
 * Mounts the delivery-address drawer on customer-facing routes only, so the
 * mandatory selector never appears on auth screens or on admin / partner /
 * restaurant portals (which may share the browser session).
 */
const EXCLUDED = new Set([
  '/customer/login',
  '/customer/register',
  '/customer/update-profile',
  '/customer/edit-profile',
  '/customer/dashboard'
]);

export default function AddressGate() {
  const { pathname } = useLocation();

  const isCustomerArea = pathname.startsWith('/customer') || pathname === '/checkout';
  if (!isCustomerArea || EXCLUDED.has(pathname)) return null;

  return <AddressDrawer />;
}
